var _style, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPattern1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 255.8 206",
    style: {
      enableBackground: "new 0 0 255.8 206"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n                        .st0{fill:none;stroke:#FCAD9A;stroke-width:3;stroke-linecap:round;}\r\n                        .st1{fill:#2163FF;}\r\n                      ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Line"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3635",
    transform: "translate(-721.038 -3829.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    className: "st0",
    d: "M754.2,3837.9c27.4,36.6,68.9,59.8,110.6,78.4c27.9,12.5,60.9,23.3,88.1,9.3                             c12.1-6.2,22.4-21,16.1-33.1c-2.6-5-7.6-8.5-12.8-10.6c-19.1-7.9-42.5,0.1-55.4,16.2c-12.9,16.1-16,38.7-11.3,58.7                             s16.6,37.9,30.9,52.8"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Dots"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3531",
    transform: "matrix(0.695, 0.719, -0.719, 0.695, 930.368, 4014.137)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    className: "st1",
    cx: -3250.6,
    cy: -2139.1,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_65",
    className: "st1",
    cx: -3236.6,
    cy: -2139.1,
    r: 4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern1);
export default __webpack_public_path__ + "static/media/pattern1.d7f85a2e.svg";
export { ForwardRef as ReactComponent };